import { useCallback, useRef, useState } from 'react';
import classNames from 'classnames';

import IconSpinner from '../IconSpinner/IconSpinner';

import css from './DownloadLink.module.css';
import { FormattedMessage } from 'react-intl';

const DownloadLink = ({ onDownload, filename, className, children }) => {
  const [inProgress, setInProgress] = useState(false);
  const [error, setError] = useState(false);
  const ref = useRef();

  const onClick = async () => {
    if (ref.current.href) {
      return;
    }

    setError(false);
    setInProgress(true);

    try {
      const blob = await onDownload();
      const href = window.URL.createObjectURL(blob);

      ref.current.download = filename;
      ref.current.href = href;

      ref.current.click();
    } catch {
      setError(true);
    } finally {
      setInProgress(false);
    }
  };

  return (
    <>
      <a {...{ ref, onClick }} className={classNames(css.link, className)}>
        {inProgress ? <IconSpinner className={css.spinner} /> : children}
      </a>
      {error && (
        <div className={css.error}>
          <FormattedMessage id="DownloadLink.error" />
        </div>
      )}
    </>
  );
};

export default DownloadLink;
